var exports = {
  "hS": "ForwardModal.module__richInput___VG12eF",
  "bo": "ForwardModal.module__destinationList___VG12eF",
  "NG": "ForwardModal.module__footerSection___VG12eF",
  "vm": "ForwardModal.module__messageInputContainer___VG12eF",
  "hj": "ForwardModal.module__messageInputContainerDisabled___VG12eF",
  "zt": "ForwardModal.module__messageInputContainerWithCounter___VG12eF",
  "pn": "ForwardModal.module__messageInputContainerWithNotice___VG12eF",
  "XK": "ForwardModal.module__slowmodeNotice___VG12eF",
  "X8": "ForwardModal.module__messageInputActions___VG12eF",
  "Vr": "ForwardModal.module__emojiPickerButton___VG12eF",
  "Z8": "ForwardModal.module__emojiPickerButtonActive___VG12eF",
  "mI": "ForwardModal.module__emojiIcon___VG12eF",
};

module.exports = exports;
